import { Component, ContentChildren, OnInit, QueryList } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { FormFieldBaseComponent } from '../form-field-base.component';
import { FormFieldPillSelectGroupItemComponent } from './form-field-pill-select-group-item.component';

@Component({
    selector: 'lib-pill-select-group',
    templateUrl: './form-field-pill-select-group.component.html',
    styleUrls: ['./form-field-pill-select-group.component.scss']
})
export class FormFieldPillSelectGroupComponent<T extends keyof any> extends FormFieldBaseComponent<T[], FormArray<FormControl<boolean>>> implements OnInit {

    private _indexMap: Record<number, T> = {};
    private _recordMap: Record<T, number> = {} as any;
    private _disabledOverrideMap: Record<number, boolean> = {};

    @ContentChildren(FormFieldPillSelectGroupItemComponent) itemQueryList!: QueryList<FormFieldPillSelectGroupItemComponent<T>>;

    constructor() {
        super();

        this.viewControl = new FormArray<FormControl<boolean>>([]);
    }

    override writeValue(keys: T[]): void {
        const allKeys = Object.keys(this._recordMap) as T[];
        allKeys.forEach(key => {
            this.viewControl.controls[this._recordMap[key]].setValue(keys?.includes(key));
        });
    }

    override ObservePristine(): void {
        // This is done below in ChangeEvent instead
    }

    ngAfterContentInit(): void {
        this.itemQueryList!.forEach((item, index) => {
            this.viewControl.Add(this.formControl.value?.includes(item.value));
            // This approach does not allow for individual pill-selects to be disabled/reenabled dynamically. If this functionality
            // is needed at some point, revisit.
            if (item.disabled) {
                this.viewControl.controls[index].disable();
                this._disabledOverrideMap[index] = true;
            } else {
                this._disabledOverrideMap[index] = false;
            }

            this._indexMap[index] = item.value;
            this._recordMap[item.value] = index;
        });
    }

    override setDisabledState(state: boolean): void {
        Object.values(this.viewControl.controls).forEach((control, index) => {
            if (!this._disabledOverrideMap[index]) {
                if (state) {
                    control.disable();
                } else {
                    control.enable();
                }
            }

        });

    }

    ChangeEvent(): void {
        let result: T[] = [];

        this.viewControl.controls.forEach((control, valueIndex) => {
            if (control.value) {
                result.push(this._indexMap[valueIndex]);
            }
        })
        this.formControl.setValue(result);
        this.SetFormControlValue(result);

        this.formControl.isDirty = true;

        super.OnBlur();
    }
}
